import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

const PrivacyPolicy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Banner */}
      <div className="bg-gradient-to-br from-[#1E1B4B] to-[#312E81] pt-28 pb-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#A78BFA] hover:text-white mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-[#6366F1]/20 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-[#A78BFA]" />
            </div>
            <span className="pill-badge bg-[#6366F1]/20 text-[#A78BFA] text-xs">Legal</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display',serif" }}>Privacy Policy</h1>
          <p className="text-sm text-white/50 font-normal">Last updated: February 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
        <div className="space-y-10">
          <div>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              Trademark Symbol Font ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Information We Collect</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed mb-3">We collect personal information that you voluntarily provide, including:</p>
            <ul className="space-y-2 ml-1">
              {['Full name', 'Email address', 'Phone number', 'Brand and trademark details', 'Business information provided through forms'].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-base font-normal text-[#4B5563]">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#6366F1] mt-2.5 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>How We Use Your Information</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              We use collected information to provide trademark registration and intellectual property services, communicate with you regarding your case, process your requests, improve our services, and comply with legal obligations. We do not sell your personal information to third parties.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Data Security</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. All data transmission is encrypted using 256-bit SSL technology.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Your Rights</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              You have the right to access, correct, or delete your personal information at any time. You may also opt out of marketing communications. To exercise any of these rights, please contact us using the information below.
            </p>
          </div>

          <div className="bg-[#F5F3FF] border border-[#EDE9FE] rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Contact Us</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              If you have questions about this Privacy Policy, contact us at{' '}
              <a href="mailto:info@trademarksymbolfont.com" className="text-[#6366F1] hover:text-[#4F46E5] font-medium">info@trademarksymbolfont.com</a>{' '}
              or visit our office at 3031 Tisch Way 110 PW, San Jose, CA 95128.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
